// Height the iframe starts at, and never shrinks below, while the dashboard reports its own size.
export const MIN_EMBED_HEIGHT = 600;

// How often the dashboard content height is re-read through the SDK. The iframe is cross-origin,
// so there is no resize event to subscribe to.
export const SCROLL_SIZE_POLL_INTERVAL = 1000;
